
import {
  ActivityLimitDto,
  CreateActivityLimitDto,
  UpdateActivityLimitDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type ActivityLimitsFilters = PaginatedQueryBase & {
  includeInactive?: boolean
  siteId?: number
}

class ActivityLimitService extends BaseCrudService<
  ActivityLimitDto,
  CreateActivityLimitDto,
  UpdateActivityLimitDto,
  ActivityLimitsFilters
> {
  constructor() {
    super('activity-limit', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const activityLimitService = new ActivityLimitService()
